export const formList = [
  { label: '库存组织', decorator: ['organizationCode'], type: 'organizationCode' },
  { label: '物料编码', decorator: ['itemCode'], type: 'input', attrs: { placeholder: '支持Excel复制批量搜索' } },
  { label: 'MBOM版本号', decorator: ['mbomVersion'], type: 'input' },
  { label: '来源PBOM版本号', decorator: ['pbomVersion'], type: 'input' },
  { label: '是否修改', decorator: ['modifyFlag'], type: 'select', options: [{ key: '1', value: '是' }, { key: '0', value: '否' }] },
  { label: '启用状态', decorator: ['effectiveFlag'], type: 'select', options: [{ key: 'Y', value: '是' }, { key: 'N', value: '否' }] },
  {
    label: '创建日期',
    type: 'range',
    decorator: ['createTime'],
    disposeFormat: {
      createTimeFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
      createTimeTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
    }
  },
  {
    label: '修改日期',
    type: 'range',
    decorator: ['updateTime'],
    disposeFormat: {
      updateTimeFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
      updateTimeTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
    }
  },
  { label: '物料名称', decorator: ['itemName'], type: 'input' },
  { label: '是否与PBOM差异', decorator: ['diffFlag'], type: 'select', options: [{ key: '1', value: '是' }, { key: '0', value: '否' }] }
];

export const columns = [
  { title: '库存组织', dataIndex: 'organizationName', align: 'center', width: 130 },
  {
    // title: '物料编码',
    dataIndex: 'itemCode',
    align: 'center',
    width: 200,
    scopedSlots: { title: "itemCodeHeader" }
  },
  { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 130 },
  { title: '物料描述', dataIndex: 'itemDescription', align: 'center', width: 250 },
  { title: '用量', dataIndex: 'componentQuantity', align: 'center', width: 100 },
  { title: '是否修改', dataIndex: 'modifyFlag', align: 'center', width: 90, customRender: (text, record) => ({ '0': '否', '1': '是' }[record.modifyFlag]) },
  { title: 'MBOM版本号', dataIndex: 'mbomVersion', align: 'center', width: 100 },
  { title: '来源PBOM版本号', dataIndex: 'pbomVersion', align: 'center', width: 100 },
  { title: '启用状态', dataIndex: 'effectiveFlag', align: 'center', width: 90, customRender: (text, record) => ({ 'N': '否', 'Y': '是' }[record.effectiveFlag]) },
  { title: '是否与PBOM差异', dataIndex: 'diffFlag', align: 'center', width: 100, customRender: (text, record) => ({ '0': '否', '1': '是' }[record.diffFlag]) },
  { title: '小工序', dataIndex: 'operationSeqNum', align: 'center', width: 90 },
  { title: '长', dataIndex: 'length', align: 'center', width: 90 },
  { title: '宽', dataIndex: 'width', align: 'center', width: 90 },
  { title: '高', dataIndex: 'height', align: 'center', width: 90 },
  { title: '备注', dataIndex: 'remark', align: 'center', width: 150 },
  { title: '生效时间', dataIndex: 'startDate', align: 'center', width: 140 },
  { title: '失效时间', dataIndex: 'endDate', align: 'center', width: 140 },
  { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
  { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
  {
    title: '操作',
    width: 90,
    align: 'center',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    stickyFixed: 'right'
  }
]
